import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=d97b1f1c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=d97b1f1c&prod&scoped=true&lang=css&"
import style1 from "./Index.vue?vue&type=style&index=1&id=d97b1f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97b1f1c",
  null
  
)

export default component.exports